import { render, staticRenderFns } from "./PreviewUsers.vue?vue&type=template&id=0acd881f&"
import script from "./PreviewUsers.vue?vue&type=script&lang=ts&"
export * from "./PreviewUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports